import { render, staticRenderFns } from "./VegiItem.vue?vue&type=template&id=b3fee846&"
import script from "./VegiItem.vue?vue&type=script&lang=js&"
export * from "./VegiItem.vue?vue&type=script&lang=js&"
import style0 from "./VegiItem.vue?vue&type=style&index=0&id=b3fee846&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports